export function addCurrent(techinicalteamorganizationcategory) {
    return {
        type: 'ADD_CURRENT',
        techinicalteamorganizationcategory,
    }
}
